module.exports = __webpack_public_path__ + "img/SALOMON-icon.a1ced29e.jpg";